<template>
    <div class="row">
        <div class="col-md-12">
            <div class="card mb-3">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="product-thumb text-center">
                                <img :src="productImage"
                                     class="img-fluid"
                                     :alt="product.name"/>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="product-description">
                                <h3>{{ product.name }} ({{ product.unit }} {{ product.unit_type }})</h3>
                                <div class="short-desc">
                                    <p v-html="product.description"></p>
                                </div>
                                <div class="price-tag mb-3">
                                    <template v-if="Boolean(Number(product.default_discount))">
                                        <del><i class="icofont-taka"></i>
                                            {{ product.sell_price }}
                                        </del>
                                        <strong>
                                            <i class="icofont-taka"></i>
                                            {{ Number(product.sell_price) - Number(product.default_discount) }}
                                        </strong>
                                    </template>
                                    <strong v-else>
                                        <i class="icofont-taka"></i>{{ product.sell_price }}
                                    </strong>
                                </div>
                                <div class="custom-qty">
                                    <button @click="decreaseQuantity"
                                            class="reduced items"
                                            type="button"
                                            :disabled="loading || isInCart(product.id)">
                                        <i class="fa fa-minus"></i>
                                    </button>
                                    <input type="text"
                                           class="input-text qty"
                                           title="Qty"
                                           maxlength="8"
                                           id="qty"
                                           name="qty"
                                           v-model="quantity"
                                    />
                                    <button @click="++quantity"
                                            class="increase items"
                                            type="button"
                                            :disabled="loading || isInCart(product.id)"
                                    >
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>
                                <div class="action-button mt-3">
                                    <button class="btn btn-danger" @click="addToCart"
                                            :disabled="loading || isInCart(product.id)">
                                        ADD TO CART
                                    </button>
                                    <!--                                    <button class="btn btn-success btn-lg font-weight-bold" title="Wishlist"><i-->
                                    <!--                                        class="fa fa-heart"></i></button>-->
                                </div>
                            </div>
                        </div>
                    </div> <!-- row close -->
                </div><!-- card body -->
            </div>
            <!--<div class="card mb-3">
                <div class="card-header card-header-tab-animation">
                    <ul class="nav nav-justified">
                        <li class="nav-item"><a data-toggle="tab" href="#tab1"
                                                class="nav-link active show">Description</a></li>
                        <li class="nav-item"><a data-toggle="tab" href="#tab2" class="nav-link show">Information</a>
                        </li>
                        <li class="nav-item"><a data-toggle="tab" href="#tab3" class="nav-link show">Information</a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                        <div class="tab-pane active show" id="tab1" role="tabpanel">
                            <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem
                                Ipsum passages, and more recently with desktop publishing
                                software like Aldus PageMaker
                                including versions of Lorem Ipsum.</p>
                        </div>
                        <div class="tab-pane show" id="tab2" role="tabpanel">
                            <p>Like Aldus PageMaker including versions of Lorem. It has survived not only five
                                centuries, but also the leap into electronic typesetting, remaining
                                essentially unchanged. </p>
                        </div>
                        <div class="tab-pane show" id="tab3" role="tabpanel">
                            <p>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
                                unknown printer took a galley of type and scrambled it to make a
                                type specimen book. It has
                                survived not only five centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged. </p>
                        </div>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
    import {optional} from "../app/Helpers/Helpers";

    export default {
        name: "ProductDetails",
        props: {
            product: {}
        },
        data() {
            return {
                loading: false,
                quantity: 1
            }
        },
        methods: {
            addToCart() {
                this.loading = true;
                window
                    .axios
                    .post(`/api/carts/${this.product.slug}`, {quantity: this.quantity})
                    .then(response => {
                        this.$store.dispatch('getCarts');
                        this.quantity = 1;
                    })
                    .finally(() => this.loading = false)
            },
            decreaseQuantity() {
                if (Number(this.quantity) < 2) {
                    this.quantity = 1;
                } else {
                    this.quantity -= 1;
                }
            },
        },
        computed: {
            productImage() {
                return Boolean(optional(this.product, 'image', 'path')) ?
                    optional(this.product, 'image', 'path') :
                    '/images/no_image.jpg';
            },
            isInCart() {
                return (product_id) => this.$store.getters.isInCart(product_id);
            }
        },
    }
</script>

<style scoped>
    .price-tag {
        font-size: 18px;
    }

    .price-tag del {
        color: red;
    }

    .custom-qty {
        display: inline-flex;
    }

    .increase.items, .reduced.items {
        background: #ddd;
        border: 1px solid #ddd;
        color: #222;
        padding: 8px 10px 7px;
        float: left;
        cursor: pointer;
    }

    .input-text.qty {
        border: 1px solid #ddd;
        max-width: 50px;
        padding: 4px 13px;
        float: left;
        text-align: center;
        margin: 0 -1px;
    }

    .card-header > .nav .nav-link.active {
        font-weight: bold;
    }
</style>